import React from "react"
import Layout from "./src/components/layout"
import { initSal } from "./src/utils/sal"

export const wrapPageElement = ({ element, props }) => <Layout {...props}>{element}</Layout>

export const onInitialClientRender = () => {
    initSal()
}

export const onRouteUpdate = () => {
    initSal()
}
